module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('gradient-canvas', {
    style: (_vm.currentRoute != 'home' ? 'opacity: 1;' : 'opacity: 0;'),
    attrs: {
      "name": "canvas-interactive",
      "default-state": "home-state"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1464a8fa!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue
// module id = 178
// module chunks = 2